import React from 'react'

export const ExternalLink: React.FC<{href: string, linkClass: string}> = (props) => {
    return <a href={props.href} rel="noopener noreferrer" target="_blank" className={props.linkClass}>{props.children}</a>
}